<template>
  <div class="box">
      <img src="https://misc.xjy.cn/zuoziji/index_bg.jpg" alt="">
<!--      <router-link class="to-buying to-buying2" to="/buying_tickets_list?city=JUU1JThDJTk3JUU0JUJBJUFDJUU1JUI4JTgyJTJGJUU1JThDJTk3JUU0JUJBJUFDJUU1JUI4JTgy">北京主会场/工作坊</router-link>-->
      <router-link class="to-buying to-buying2" to="/buying_tickets_list?city=JUU1JUI5JUJGJUU0JUI4JTlDJUU3JTlDJTgxLyVFNSVCOSVCRiVFNSVCNyU5RSVFNSVCOCU4Mg%3D%3D">购买门票</router-link>
<!--      <router-link class="to-buying" to="/buying_tickets">分会场</router-link>-->
      <router-link class="to-buying to-buying3" to="/personal">我的门票</router-link>
  </div>
</template>

<script>
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{

        }
    },
    methods:{
        
    },
    created(){
        shareCon("beMyself", this);
      document.title = "新精英生涯-做自己节售票系统"
    }
}
</script>

<style lang="scss" scoped>
.box{
    padding-bottom: 100px;
    img{
        width: 100%;
    }
    .to-buying{
        display: block;
        //width: 225px;
        width: 375px;
        height: 100px;
        line-height: 100px;
        text-align: center;
        background: #fa7471;
        font-size: 32px;
        font-weight: 600;
        color: #FFFFFF;
        position: fixed;
        bottom: 0;
        left: 55%;
        transform: translateX(-50%);
    }
    .to-buying2{
        left: 25%;
        font-size: 32px;
        background: #fedf13;
        color: #ff504c;
        //width: 300px;
    }
    .to-buying3{
        left: 75%;
        background: #ff504c;
    }
}
</style>